export default from './search-button';



// WEBPACK FOOTER //
// ./app/components/search-button/index.js